import type { MarkedToken, Tokens } from 'marked';
import type { ComponentType, Ref } from 'react';

import type { ErrorStateProps, ExcludeStrict, TestIdProp } from '@pega/cosmos-react-core';

export interface InteractionRenderers {
  type: string;
  regexPattern: RegExp;
  xmlElement?: string;
  component?: ComponentType<any>;
  getSearchAttributes?: (
    xmlElement: string,
    searchResult: string
  ) =>
    | { markdown: string; component: ComponentType<any>; props: Record<string, any>; text: string }
    | undefined;
}

export type TokenMap = {
  [K in ExcludeStrict<MarkedToken, Tokens.Def>['type']]: Extract<MarkedToken, { type: K }>;
};

export type MDMap = {
  [K in ExcludeStrict<MarkedToken, Tokens.Def>['type']]?: (
    token: TokenMap[K]
  ) => ComponentType<{ token: TokenMap[K] }> | undefined;
};

export type RichTextViewerProps = TestIdProp & {
  content: string;
  interactionRenderers?: InteractionRenderers[];
  markdownMap?: MDMap;
  onRetry?: ErrorStateProps['onRetry'];
  ref?: Ref<HTMLDivElement>;
} & (
    | { type: 'markdown'; onMarkdownLinkRender?: (href: string) => void; renderHTML?: boolean }
    | { type: 'html' | 'richtext'; onMarkdownLinkRender?: never; renderHTML?: never }
  );
